import { action, computed, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../api/RemoteResourceV3';
import { WithdrawalApis } from '../../mainv3/apis/withdrawals';
import { WithdrawalId } from '../types/withdrawals';

export class WithdrawalState {
    @observable withdrawalBase = RemoteResourceV3.loading();
    @action.bound
    async init() {
        await this.reload();
    }

    @action.bound
    async reload() {
        await updateRemoteResourceV3(
            this.withdrawalBase,
            (v) => (this.withdrawalBase = v),
            () => WithdrawalApis.show()
        );
    }

    @action.bound
    async cancel(withdrawalId: WithdrawalId) {
        await WithdrawalApis.cancel(withdrawalId);
    }

    @computed
    get isWithdrawalSet() {
        return this.withdrawalBase.getOrElse(null) != null;
    }

    @computed
    get withdrawal() {
        return this.withdrawalBase.get();
    }

    @computed
    get withdrawalId() {
        if (!this.isWithdrawalSet) {
            return null;
        }
        const withdrawal = this.withdrawalBase.get();
        if (!withdrawal) {
            return null;
        }
        return withdrawal.id;
    }

    @computed
    get withdrawalEffectiveAt() {
        if (!this.isWithdrawalSet) {
            return null;
        }
        const withdrawal = this.withdrawalBase.get();
        if (!withdrawal) {
            return null;
        }
        return withdrawal.effective_at;
    }

    @computed
    get loading() {
        return this.withdrawalBase.loading;
    }
}
